import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cityName: null,
};

const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    setCityName: (state, action) => {
      state.cityName = action.payload;
    },
    clearCityName: (state) => {
      state.cityName = "";
    },
  },
});


export const { setCityName, clearCityName } = citySlice.actions;

export default citySlice.reducer;
